import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";

export const getProjection = async (epsgCode: number) => {
  var request: RestApiRequest = {
    url: `/api/map/projection?epsgCode=${epsgCode}`,

    method: "GET",
  };
  const response = await fetchData(request);

  return response;
};
